import * as React from 'react';
import { PaginationListViewModelImpl } from '../../../../../../ui/toolkit/verticallist/paginationverticallist/paginationlistviewmodel';
import { MemberDetailsRowCSSStyle, MemberDetailsRowCSSStyleImpl } from './memberdetailsrowcss';
import { MemberDetailsDto } from '../../../../../../core/dto/listtones/memberdetailsdto';
import { MemberDetailsRowComponent } from './memberdetailsrowcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ManageGroupType } from '../managegrouptype';
import { ManageGroupMemberHandler } from '../managegroupview';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import './members-details-style.css';

export class MemberDetailsViewModelImpl extends PaginationListViewModelImpl<MemberDetailsDto>
{
    private cssStyle:MemberDetailsRowCSSStyle;
    private manageGroupType: ManageGroupType;

    constructor(offset: number, context: BaseContext, private manageGroupMemberHandler: ManageGroupMemberHandler)
    {
        super(offset, context);

        this.cssStyle = new MemberDetailsRowCSSStyleImpl(context);

        this.onAddMemberClicked = this.onAddMemberClicked.bind(this);
    }

    setManageGroupType(manageGroupType: ManageGroupType)
    {
        this.manageGroupType = manageGroupType;
    }

    getView(t: MemberDetailsDto, position: number): boolean | JSX.Element 
    {
        return <MemberDetailsRowComponent onAddMemberClicked={this.onAddMemberClicked} onDeleteMemberClicked={this.manageGroupMemberHandler.onDeleteMemberClicked} manageGroupType={this.manageGroupType} key={position}  context={this.getContext()} memberDetailsDto={t}  position={position}/>;
    }

   onAddMemberClicked(memberDetailsDto: MemberDetailsDto)
   {
      this.manageGroupMemberHandler.onAddMemberClicked(memberDetailsDto);
   }

    getHeader():boolean|JSX.Element
    {
        return(
            
            <tr id="members-details-header-row"> 
            <th id="members-details-header-name-td">
            <div id="members-details-header-name-div">
            <label style={this.cssStyle.getHeader1DivCSSStyle()}>
                                {this.getContext().getResources().getString(Strings.member_name)}
                         {this.manageGroupType !== ManageGroupType.VIEW && <label style={this.cssStyle.getHeader2DivCSSStyle()}>
                            {"*"}
                         </label>}
                         </label>
            </div>
            </th>
            <th id="members-details-header-msisdn-td">
            <div id="members-details-header-msisdn-div">
                 <label style={this.cssStyle.getHeader1DivCSSStyle()}>
                        {this.getContext().getResources().getString(Strings.mobilenumber)}
                        {this.manageGroupType !== ManageGroupType.VIEW && <label style={this.cssStyle.getHeader2DivCSSStyle()}>
                             {"*"}
                             </label>}
                         </label>
                </div>
             </th>
         </tr>  
        );
    }


}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/membersdetails/memberdetailsviewmodel.tsx